import { all, fork } from 'redux-saga/effects'

import postActivitiesSaga from './postActivitiesSaga'
import postActivitySaga from './postActivitySaga'
import putActivitySaga from './putActivitySaga'
import bulkAddActivitiesSaga from './bulkAddActivitiesSaga'
import uploadActivitiesImageSaga from './uploadActivitiesImageSaga'
import showModalsWithImageCropperSaga from './showModalsWithImageCropperSaga'

export default function* activitiesSaga() {
  yield all([
    fork(postActivitiesSaga),
    fork(postActivitySaga),
    fork(putActivitySaga),
    fork(bulkAddActivitiesSaga),
    fork(uploadActivitiesImageSaga),
    fork(showModalsWithImageCropperSaga),
  ])
}
